<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" sm="4">
        <v-card flat style="background-color: transparent">
          <v-card-actions>
            <v-text-field
              style="margin-top: 2px !important"
              class="search-box"
              placeholder="Search Courses By Name"
              prepend-icon="fa-search"
              v-model="search"
              type="text"
              clearable
              clear-icon="fa-times"
              @click:clear="resetSearch"
              @keyup="applySearch"
            ></v-text-field>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col md="12">
        <v-card flat>
          <v-skeleton-loader v-if="loading && isTabletOrDesktop" type="table" :types="{ 'table-heading': '' }"></v-skeleton-loader>
            <v-skeleton-loader v-if="loading && !isTabletOrDesktop" type="table" :types="{ 'table-heading': '', 'table-thead' : 'heading@1' ,'table-row':'text@1'}" class="slider-table"></v-skeleton-loader>
          <v-data-table
            v-model="selected"
            :headers="headers"
            :options.sync="options"
            :server-items-length="serverItemsLength"
            v-show="!loading"
            :items="courses"
            item-key="id"
          >
          <template class="d-flex-inline" v-slot:item.name="{ item }">
                <div class="sm-inline-flex text-center">
                  <table-thumb :thumb="item"></table-thumb>
                  <span class="three-dots ml-2 mt-auto mb-auto">{{
                    item.name
                  }}</span>
                </div>
              </template>
            <template v-slot:item.published="{ item }">
              <v-icon v-if="item.published" color="green" small
                >fa-check</v-icon
              >
              <v-icon v-else color="red" small>fa-times</v-icon>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { EventBus } from '@/event-bus.js';
import courseAPI from '@/api/course.js';
import testAPI from '@/api/test.js';
import TableThumb from '@/components/admin/course/TableThumb';
import EditCourse from '@/components/admin/course/Edit';
import CreateCourse from '@/components/admin/course/Create';
import EnrolUsers from '@/components/admin/course/Enrol';
import ManageDeadlines from '@/components/admin/course/ManageDeadlines';
import RemoveUsers from '@/components/admin/course/RemoveUsers';
import CreateTest from '@/components/admin/course/AddTest';

export default {
  name: 'SuperAdminCompanyCourses',
  components: {
    TableThumb,
  },
  data() {
    return {
      headers: [
        { text: 'Published', value: 'published', sortable: false, align: 'center'},
        { text: 'Course', value: 'name' },
        { text: 'Total Users', value: 'total_users', sortable: false },
        { text: 'In Progress', value: 'total_inprogress', sortable: false },
        { text: 'Completed', value: 'total_completed', sortable: false },
        { text: 'Not Started', value: 'total_not_started', sortable: false },
      ],
      courses: [],
      search: '',
      timer: null,
      fetchTimer: null,
      pagination: {},
      options: {},
      loading: false,
      searchParams: '',
      companyId: this.$route.params.id,
      selected: [],
      confirmDelete:
        'Are you sure you want to delete this course? All Course users and associated data will be removed.',
    };
  },
  computed: {
    serverItemsLength: function () {
      return this.pagination.total;
    },
    itemsPerPage: function () {
      return this.pagination.per_page;
    },
    page: function () {
      return this.pagination.current_page;
    },
    params: function () {
      return this.$gf.getQueryString(this.options, this.serverItemsLength);
    },
    hasTest: function () {
      return this.test == null ? false : true;
    },
    test: function () {
      return this.course.hasOwnProperty('test')
        ? this.course.test.data.id
        : null;
    },
    isTabletOrDesktop() {
      const width = this.$vuetify.breakpoint.width;
      return width >= 820;
    },
  },
  watch: {
    options: {
      handler() {
        this.queueFetch();
      },
      deep: true,
    },
  },
  mounted() {
    this.setEventBus();
  },
  beforeDestroy() {
    // Otherwise a pending debounce fires on a torn-down component, mutating
    // dead state and issuing a request whose response has nowhere to land.
    clearTimeout(this.timer);
  },
  methods: {
    createTest(id) {
      testAPI.createTest(id).then((resp) => {
        this.$router.push('/admin/courses/test/' + resp.data.data.id);
      });
    },
    deleteCourse(id) {
      this.$snotify.confirm(this.confirmDelete, {
        backdrop:0.3,                        
        buttons: [
          { text: 'Cancel',className: 'toast-cancel-button' },
          {
            text: 'Continue',
            className: 'toast-continue-button',
            action: (toast) => this.processDeleteCourse(toast, id),
          }          
        ],
      });
    },
    processDeleteCourse(toast, id) {
      this.$snotify.remove(toast.id);
      courseAPI.deleteCourse(id).then((response) => {
        this.getCourses();
      });
    },
    editTest(id) {
      this.$router.push('/admin/courses/test/' + id);
    },
    publishCourses() {
      let selected = this.selected.map(function (x) {
        return x.id;
      });
      courseAPI.togglePublish(selected, true).then((resp) => {
        this.getCourses();
      });
    },
    unpublishCourses() {
      let selected = this.selected.map(function (x) {
        return x.id;
      });
      courseAPI.togglePublish(selected, false).then((resp) => {
        this.getCourses();
      });
    },
    applySearch() {
      // Debounced so a search fires once the admin stops typing, not per keystroke.
      clearTimeout(this.timer);
      this.timer = setTimeout(this.runSearch, 1000);
    },
    resetSearch() {
      clearTimeout(this.timer);
      this.search = '';
      this.runSearch();
    },
    runSearch() {
      // searchParams carries ONLY the &search= fragment. getCourses already
      // supplies params and the includes; prefixing them here produced a URL
      // with two '?' and silently dropped the page number.
      this.searchParams = this.search
        ? '&search=name:' + encodeURIComponent(this.search)
        : '';
      // One fetch, whatever happens. Resetting the page makes the deep watcher
      // fire, and Vuetify can emit more than one options update per change, so
      // both paths go through the same queue rather than racing each other.
      // This endpoint still takes 30 seconds on production, so a duplicate is
      // not a cosmetic problem.
      this.options.page = 1;
      this.queueFetch();
    },
    queueFetch() {
      // Collapses the burst of watcher fires a page or search change produces
      // into exactly one request.
      clearTimeout(this.fetchTimer);
      this.fetchTimer = setTimeout(this.getCourses, 50);
    },
    getCourses() {
      this.loading = true;
      courseAPI
        .getCourses(
          this.params + '&include=thumbnail,test',
          this.searchParams,
          this.companyId
        )
        .then((resp) => {
          this.courses = resp.data.data;
          this.pagination = resp.data.meta.pagination;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    setEventBus() {
      EventBus.$on('COURSES_UPDATED', (payload) => {
        this.params = payload;
        this.getCourses();
      });
    },
    showEditPanel(id) {
      this.$showPanel({
        component: EditCourse,
        props: {
          id: id,
          params: this.params,
        },
        openOn: 'right',
      });
    },
    showCreateTestPanel(id) {
      this.$showPanel({
        component: CreateTest,
        props: {
          id: id,
        },
        openOn: 'right',
      });
    },
    showCreatePanel() {
      this.$showPanel({
        component: CreateCourse,
        props: {
          params: this.params,
        },
        openOn: 'right',
      });
    },
    showEnrolPanel(id) {
      this.$showPanel({
        component: EnrolUsers,
        disableBgClick: true,
        props: {
          id: id,
          params: this.params,
        },
        openOn: 'right',
      });
    },
    showManageDeadlinesPanel(id) {
      this.$showPanel({
        component: ManageDeadlines,
        disableBgClick: true,
        props: {
          id: id,
          params: this.params,
        },
        openOn: 'right',
      });
    },
    showRemoveUsersPanel(id) {
      this.$showPanel({
        component: RemoveUsers,
        disableBgClick: true,
        props: {
          id: id,
          params: this.params,
        },
        openOn: 'right',
      });
    },
  },
};
</script>
